/**
 * Constants for ContentManagerPage
 *
 * Centralizes magic strings and configuration values for maintainability.
 */

/** Section identifiers for content navigation */
export const CONTENT_SECTIONS = {
	TRASH: 'trash',
	STARRED: 'starred',
	RECENT: 'recent',
	SHARED: 'shared',
	PLAYBOOKS: 'playbooks',
	PRESENTATIONS: 'presentations',
	DOCUMENTS: 'documents',
} as const

export type ContentSection = (typeof CONTENT_SECTIONS)[keyof typeof CONTENT_SECTIONS]

/** Onboarding tour identifier */
export const CONTENT_MANAGER_TOUR_ID = 'content-manager'

/** Selection key utilities - format: "type:id" */
export const SELECTION_KEY_SEPARATOR = ':'

export function createSelectionKey(type: string, id: number | string): string {
	return `${type}${SELECTION_KEY_SEPARATOR}${id}`
}

export function parseSelectionKey(key: string): { type: string; id: string } | null {
	const parts = key.split(SELECTION_KEY_SEPARATOR)
	if (parts.length !== 2 || !parts[0] || !parts[1]) {
		console.warn(`Invalid selection key format: "${key}"`)
		return null
	}
	return { type: parts[0], id: parts[1] }
}

/** Modal names for useModalManager */
export const CONTENT_MANAGER_MODALS = [
	'newPlaybook',
	'newPresentation',
	'newDocument',
	'settings',
	'manageTeams',
	'newFolder',
	'share',
	'addToFolder',
	'rename',
] as const

export type ContentManagerModalName = (typeof CONTENT_MANAGER_MODALS)[number]

/** Sidebar panel configuration */
export const SIDEBAR_CONFIG = {
	BASELINE_VIEWPORT: 1440,
} as const
